// carta quotidiano.net: https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/kiosk.html
// sfogliatore quotidiano.net: https://abbonamenti.quotidiano.net/vpweb/magazines/MRED/newsstand/kiosk.html

// carta IRDC: https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=CARLINO
// sfogliatore IRDC: https://abbonamenti.quotidiano.net/vpweb/magazines/MRED/newsstand/purchase.html?mag=CARLINO

// carta IG: https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=GIORNO
// sfogliatore IG: https://abbonamenti.quotidiano.net/vpweb/magazines/MRED/newsstand/purchase.html?mag=GIORNO

// carta IG: https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=NAZIONE
// sfogliatore IG: https://abbonamenti.quotidiano.net/vpweb/magazines/MRED/newsstand/purchase.html?mag=NAZIONE

const baseUrlCartaTestate =
  'https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=';

export const abinsulaLinks = {
  qn: {
    sfogliatore: 'https://abbonati.quotidiano.net/ilrestodelcarlino/index.html',
    carta: 'https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/kiosk.html',
  },
  ilresto: {
    sfogliatore: 'https://abbonati.quotidiano.net/ilrestodelcarlino/index.html',
    carta: `${baseUrlCartaTestate}CARLINO`,
  },
  ilgiorno: {
    sfogliatore: 'https://abbonati.quotidiano.net/ilgiorno/index.html',
    carta: `${baseUrlCartaTestate}GIORNO`,
  },
  lanazione: {
    sfogliatore: 'https://abbonati.quotidiano.net/lanazione/index.html',
    carta: `${baseUrlCartaTestate}NAZIONE`,
  },
};
